import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskTicketTypeFieldsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-ticket-type-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?',
};
